/** Copy for /b2b Benny 360 kW roaming case. Keep in sync with sales/ukraine/CASE_BENNY_ROAMING.md */

export const B2B_BENNY_CASE_COPY = {
  ua: {
    figureAlt: 'Без OCPI — одна мапа і мало трафіку. З OCPI — 5+ мап і +18% трафіку',
    stat: '+18%',
    statCaption: 'трафіку показав роумінг',
    headline: 'Станція лише на одній мапі. Трафіку мало. Знайома історія?',
    introBefore: 'Зараз розкажемо, як ',
    siteName: '220-km.com',
    introMid: ' і роумінг з ',
    evaName: 'EVA',
    introComma: ', ',
    evBoostName: 'EVBOOST',
    introAnd: ' та ',
    evUaName: 'EV\u00a0UA',
    introAfter: ' показали +18% трафіку на DC-зарядці Benny 360 кВт.',
    lead: 'Партнер 220-km: DC fast charger Benny, 360 кВт.',
    prices: [
      { value: '11,99 грн', name: '220-km.com', href: 'https://220-km.com/' },
      { value: '12,99 грн', name: 'великий оператор' },
    ],
    smmTagsLabel: 'Теми',
    smmTags: ['дешева зарядка', 'найдешевша зарядка', 'де зарядитись при вимкненні світла'],
    wasTitle: 'Було',
    wasBody: ['Станцію бачили лише на одній мапі. Водії з інших додатків її не знаходили.'],
    changedTitle: 'Що змінили',
    changedBody: ['Підключили 220-km.com і роумінг з EVA, EVBOOST та EV UA. Через OCPI станція зʼявилась на 5+ мапах.'],
    betterTitle: 'Стало',
    betterBody: [
      'Водії знаходять станцію не в одному додатку, а на 5+ мапах і в додатках. Станція зʼявилась на Google Maps, у всіх європейських білінгах та на нативних мапах автовиробників через Octopus OCPI.',
      'Роумінг показав +18% трафіку проти одного з найбільших операторів великої трійки в Україні.',
    ],
    tableCaption: 'До роумінгу — одна мапа. Після роумінгу — 5+ мап через OCPI.',
    colStage: '',
    colBefore: 'До роумінгу',
    colAfter: 'Після роумінгу',
    rowMaps: 'Мапи',
    beforeMaps: '1',
    afterMaps: '5+ через OCPI',
    outcomes: [
      { value: '+18%', text: 'обсягу в кВт·год за рахунок більшої кількості водіїв' },
      { value: '', text: 'дешевший білінг з виплатами раз на день' },
    ],
    source:
      'Порівняння трафіку DC-зарядки Benny 360 кВт: 220-km.com і роумінг EVA, EVBOOST та EV UA проти одного з найбільших операторів великої трійки в Україні.',
  },
  ru: {
    figureAlt: 'Без OCPI — одна карта и мало трафика. С OCPI — 5+ карт и +18% трафика',
    stat: '+18%',
    statCaption: 'трафика показал роуминг',
    headline: 'Станция только на одной карте. Трафика мало. Знакомая история?',
    introBefore: 'Сейчас расскажем, как ',
    siteName: '220-km.com',
    introMid: ' и роуминг с ',
    evaName: 'EVA',
    introComma: ', ',
    evBoostName: 'EVBOOST',
    introAnd: ' и ',
    evUaName: 'EV\u00a0UA',
    introAfter: ' показали +18% трафика на DC-зарядке Benny 360 кВт.',
    lead: 'Партнёр 220-km: DC fast charger Benny, 360 кВт.',
    prices: [
      { value: '11,99 грн', name: '220-km.com', href: 'https://220-km.com/' },
      { value: '12,99 грн', name: 'крупный оператор' },
    ],
    smmTagsLabel: 'Темы',
    smmTags: ['дешева зарядка', 'найдешевша зарядка', 'де зарядитись при вимкненні світла'],
    wasTitle: 'Было',
    wasBody: ['Станцию видели только на одной карте. Водители из других приложений её не находили.'],
    changedTitle: 'Что изменили',
    changedBody: ['Подключили 220-km.com и роуминг с EVA, EVBOOST и EV UA. Через OCPI станция появилась на 5+ картах.'],
    betterTitle: 'Стало',
    betterBody: [
      'Водители находят станцию не в одном приложении, а на 5+ картах и в приложениях. Станция появилась на Google Maps, во всех европейских биллингах и на нативных картах автопроизводителей через Octopus OCPI.',
      'Роуминг показал +18% трафика против одного из крупнейших операторов большой тройки в Украине.',
    ],
    tableCaption: 'До роуминга — одна карта. После роуминга — 5+ карт через OCPI.',
    colStage: '',
    colBefore: 'До роуминга',
    colAfter: 'После роуминга',
    rowMaps: 'Карты',
    beforeMaps: '1',
    afterMaps: '5+ через OCPI',
    outcomes: [
      { value: '+18%', text: 'объёма в кВт·ч за счёт большего числа водителей' },
      { value: '', text: 'более дешёвый биллинг с выплатами раз в день' },
    ],
    source:
      'Сравнение трафика DC-зарядки Benny 360 кВт: 220-km.com и роуминг EVA, EVBOOST и EV UA против одного из крупнейших операторов большой тройки в Украине.',
  },
  en: {
    figureAlt: 'Without OCPI: one map and little traffic. With OCPI: 5+ maps and +18% traffic',
    stat: '+18%',
    statCaption: 'traffic, shown by roaming',
    headline: 'The charger is on one map only. Too little traffic. Sound familiar?',
    introBefore: 'Here is how ',
    siteName: '220-km.com',
    introMid: ' and roaming with ',
    evaName: 'EVA',
    introComma: ', ',
    evBoostName: 'EVBOOST',
    introAnd: ', and ',
    evUaName: 'EV\u00a0UA',
    introAfter: ' showed +18% traffic on the Benny 360 kW DC charger.',
    lead: 'A 220-km partner: Benny DC fast charger, 360 kW.',
    prices: [
      { value: 'UAH 11.99', name: '220-km.com', href: 'https://220-km.com/' },
      { value: 'UAH 12.99', name: 'a large operator' },
    ],
    smmTagsLabel: 'Topics',
    smmTags: ['дешева зарядка', 'найдешевша зарядка', 'де зарядитись при вимкненні світла'],
    wasTitle: 'Before',
    wasBody: ['The charger was on one map only. Drivers in other apps did not find it.'],
    changedTitle: 'What changed',
    changedBody: [
      'We connected 220-km.com and roaming with EVA, EVBOOST, and EV UA. Via OCPI the charger is on 5+ maps.',
    ],
    betterTitle: 'After',
    betterBody: [
      'Drivers find the charger on 5+ maps and in multiple apps, not in a single app. The charger showed up on Google Maps, in every European billing system, and on car makers’ native maps via Octopus OCPI.',
      'Roaming showed +18% traffic versus one of the largest operators in Ukraine’s big three.',
    ],
    tableCaption: 'Before roaming: one map. After roaming: 5+ maps via OCPI.',
    colStage: '',
    colBefore: 'Before roaming',
    colAfter: 'After roaming',
    rowMaps: 'Maps',
    beforeMaps: '1',
    afterMaps: '5+ via OCPI',
    outcomes: [
      { value: '+18%', text: 'kWh volume from more drivers' },
      { value: '', text: 'cheaper billing with payouts once a day' },
    ],
    source:
      'Traffic comparison for the Benny 360 kW DC charger: 220-km.com and EVA, EVBOOST, and EV UA roaming versus one of the largest operators in Ukraine’s big three.',
  },
};

export function getB2bBennyCaseCopy(language) {
  const lang = String(language || 'ua').toLowerCase();
  if (lang.startsWith('en')) return B2B_BENNY_CASE_COPY.en;
  if (lang.startsWith('ru')) return B2B_BENNY_CASE_COPY.ru;
  return B2B_BENNY_CASE_COPY.ua;
}
